<template>
  <div class="property_wrap">
    <div class="pro_top">预约</div>
    <div class="pro_con">
      <el-form label-width="80px">
         <el-form ref="form" label-width="80px">
          <el-form-item label="封面图">
            <div class="addicon">
              <div class="el-upload el-upload--text" >
                <template  v-if="form.cover_img">
                    <img  :src="form.cover_img" class="avatar">
                    <div @click.stop="handleDelImg" class="del_btn">
                      <span class="whd-video__span" ><i class="el-icon-delete"></i></span>
                    </div>
                </template>
                
                <i v-else class="el-icon-plus avatar-uploader-icon" @click="changeList(1)"></i>
              </div>
            </div> 
            <p>(图片大小不超过2M,支持jpg、png格式，建议尺寸750*320，实际显示尺寸375*160)</p>
          </el-form-item>
          <el-form-item label="标题:">
            <el-input
                placeholder="请输入标题"
                v-model="form.goods_title">
                <i slot="suffix" class="el-input__icon el-icon-edit" @click="handleIconClick"></i>
              </el-input>
              <p class="infodescribe">(根据不同的企业的情况，可修改标题名称，例：医疗行业《预约项目》)</p>
          </el-form-item>
          <el-form-item label="选择商品:">
            <el-button size="mini" type="success" @click="chooseCartId(1)" >添加</el-button>
            <!-- 商品表单信息 -->
           <div class="yy_table">
              <el-table
                :data="curPageGoods_list"
                style="width: 100%">
                <el-table-column
                  prop="goods_name"
                  label="商品名称"
                  width="180">
                </el-table-column>
                <el-table-column
                  label="有效期"
                  width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.date_begin | timefilter }}</span>
                    <span>-</span>
                    <span>{{scope.row.date_end | timefilter}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row,1)" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pag_wrap">
                <el-pagination
                  background
                  :page-size="page.page_size"
                  :current-page="page.current_page"
                  layout="total, prev, pager, next"
                  :total="page.total_rows"
                  @current-change="pageIndexChange"
                ></el-pagination>
              </div>
           </div>
          </el-form-item>
          <el-form-item label="标题:">
            <el-input
                placeholder="请输入标题"
                v-model="form.employee_title">
                <i slot="suffix" class="el-input__icon el-icon-edit" @click="handleIconClick"></i>
              </el-input>
              <p class="infodescribe">(根据不同的企业的情况，可修改标题名称，例：医疗行业《预约医师》)</p>
          </el-form-item>
           <el-form-item label="选择成员:">
            <el-button size="mini" type="success" @click="chooseCartId(2)">添加</el-button>
            <!-- 表单信息 -->
            <div class="yy_table">
                <el-table
                  :data="curPageEmployee_list"
                  style="width: 100%">
                  
                  <el-table-column  prop="employee_name" label="员工名称" width="180">
                  </el-table-column>
                  <el-table-column  label="有效期" width="180">
                    <template slot-scope="scope">
                    <span>{{scope.row.date_begin | timefilter }}</span>
                    <span>-</span>
                    <span>{{scope.row.date_end | timefilter}}</span>
                  </template>
                  </el-table-column>
                  <el-table-column  label="操作">
                    <template slot-scope="scope">
                      <el-button @click="handleClick(scope.row,2)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="pag_wrap">
                <el-pagination
                  background
                  :page-size="eypage.page_size"
                  :current-page="eypage.current_page"
                  layout="total, prev, pager, next"
                  :total="eypage.total_rows"
                  @current-change="eypageIndexChange"
                ></el-pagination>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </el-form>
     
 
    </div>
    <chooseManagerDialog
            :visible.sync="choosedepdialog"
            @userDetail="userDetail"
            v-if="choosedepdialog"
            :typeDialog="typeDialog"
            @choosedepsucess="choosedepsucess"
    ></chooseManagerDialog>
 
    <yuyueDialog :visible.sync="dialogActivity" :type="titletype" @updatePageInfo="updatePageInfo"></yuyueDialog>
    <corpper :visible.sync="corppervisible"
          v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize" :type="18"></corpper>
  </div>
</template>
<script>
  import api from "@/api.js";
  import { yeartime } from "../../assets/js/common"
  import chooseManagerDialog from "@/components/dialog/chooseManagerDialog.vue";
  import yuyueDialog from '@/components/dialog/yuyueDialog';
  import corpper from "@/components/dialog/corpper.vue";
  export default {
    props: ["property"],
    filters: { // 限制文本显示字数,超出部分用...代替
			timefilter (time) {
        return yeartime(time)
			}
		},
    components: {
      yuyueDialog,corpper
    },
    
    data() {
      return {
        typeDialog: 3,
        titletype:1,
        choosedepdialog:false,
        dialogVisible: false,
        dialogActivity: false,
        defultImg: '/static/img/userDefult.png',
        activeImg: 0,
        form: {
          label: '',
          cover_img:"",
          goods_title:"",
          goods_list:[],
          employee_title:"",
          employee_list:[]
        },
        curPageGoods_list:[],//当前页的商品列表
        curPageEmployee_list:[],//当前页的员工列表
        corppervisible: false,
        imgSize: 18,
        page: {
					current_page:1,
					page_size: 5,
					total_rows: 1,//总条目数
        },
        eypage: {
					current_page:1,
					page_size: 5,
					total_rows: 1,//总条目数
				},
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          this.form = val
          this.pageData(this.page.current_page,this.form.goods_list,this.page.page_size,1)
          this.page.total_rows = this.form.goods_list.length
          this.pageData(this.eypage.current_page,this.form.employee_list,this.eypage.page_size,2)
          this.eypage.total_rows = this.form.employee_list.length
          // console.log('12212121====',this.form)
        }
      }
    },
    created() {
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
      pageIndexChange(pageindex) {
        // console.log('fenye-----',pageindex)
		    this.page.current_page = pageindex;
		    this.pageData(this.page.current_page,this.form.goods_list,this.page.page_size,1);
      },
      eypageIndexChange(pageindex) {
        // console.log('fenye-----',pageindex)
		    this.eypage.current_page = pageindex;
		    this.pageData(this.eypage.current_page,this.form.goods_list,this.eypage.page_size,2);
      },
      //分页计算显示的数据
      pageData(page,data,pageSize,type){
        let stat = (page-1) * pageSize
        let end = page * pageSize
        let newArr = JSON.parse(JSON.stringify(data))
 
        if(type == 1){
          //员工分页
          this.curPageGoods_list = newArr.slice(stat,end)
          // console.log(this.curPageGoods_list)
          // this.page.current_page +=1
        }else{
          this.curPageEmployee_list = newArr.slice(stat,end)
          //  this.page.current_page +=1
        }
       
      },
      chooseCartId(index) {
        this.titletype = index;
        this.dialogActivity = true;
      },
      
      updatePageInfo(option,val) {
        // console.log('选中--',option)
        if(val == 1){
          let new_goods_list = this.form.goods_list.concat(option)
          this.form.goods_list = this.arrayUnique2(new_goods_list ,'id').reverse()
          this.page.current_page =1
          this.page.total_rows = this.form.goods_list.length
          this.pageData(this.page.current_page,this.form.goods_list,this.page.page_size,1)
        }else{
          let new_employee_list = this.form.employee_list.concat(option)
          this.form.employee_list = this.arrayUnique2(new_employee_list ,'id').reverse()
           this.eypage.current_page =1
          this.eypage.total_rows = this.form.employee_list.length
          this.pageData(this.eypage.current_page,this.form.employee_list,this.eypage.page_size,2)
        }
       
    },
      /*
        去重并保留最后出现的那个
        reducer 函数接收4个参数:
            Accumulator (acc) (累计器)
            Current Value (cur) (当前值)
            Current Index (index) (当前索引)
            Source Array (srcArray) (源数组)
        */
      arrayUnique2(arr, name) {
          var hash = {};
          return arr.reduce(function (acc, cru,index) {
              if (!hash[cru[name]]) {
                  hash[cru[name]] = {index:index}
                  acc.push(cru)
              }else{
                  acc.splice(hash[cru[name]]['index'],1,cru)
              }
              return acc;
          }, []);
      },
      handleClick(items,type) {
        if(type == 1){
          this.form.goods_list.forEach((item,index) => {
            if(item.id == items.id){
              this.form.goods_list.splice(index, 1);
            }
          });
          
          this.page.total_rows = this.form.goods_list.length
          this.pageData(this.page.current_page,this.form.goods_list,this.page.page_size,1)
        }else{
          this.form.employee_list.forEach((item,index) => {
            if(item.id == items.id){
              this.form.employee_list.splice(index, 1);
            }
          });
          this.eypage.total_rows = this.form.employee_list.length
          this.pageData(this.eypage.current_page,this.form.employee_list,this.eypage.page_size,2)
        }
        
      },
      userDetail(option) {
        this.axios
            .post(api.employee_detail, {em_id: option.id})
            .then(response => {
              if (response.data.code == 0) {
                // this.form.list.push({id:'',name: '姓名', position: '职位', mobile: '手机号码', pic: this.defultImg, is_link: '0'})
                let option = this.form.list[this.clickIndex];
                option.id = response.data.info.id;
                option.name = response.data.info.name;
                option.position	 = response.data.info.position;
                option.mobile = response.data.info.phone;
                option.pic = response.data.info.pic;
                this.form.employee_list[this.clickIndex] = option;
                this.choosedepdialog = false;
              } else {
              }
            })
            .catch(response => {
            });
      },
      handleIconClick(){

      },
      choosedepsucess() {

      },
    
      closeTeamList(index) {
        this.form.list.splice(index, 1)
      },
      changeList(index) {
        this.activeImg = index
        this.corppervisible = true
      },
      raidoChange(index){
        if(this.form.list[index].is_link!==1){
          this.form.list[index].id = ''
          this.form.list[index].uname = ''
        }
      },

      imgAddBack(option) {
       this.form.cover_img = option
      },
      handleDelImg() {
      this.form.cover_img = "";
    }
    }
  };
</script>

<style scoped>
.addicon .avatar{width: 120px; height: 141px; object-fit: cover;}
.del_btn{position: absolute; top: 0; right: 0; left: 0; bottom: 0; background: rgba(0,0,0,0.5);opacity: 0; transition: opacity .3s; visibility: hidden; z-index: 5;}
.el-upload{position: relative;}
.el-upload:hover .del_btn{opacity: 1; visibility: visible;}
.el-upload .del_btn .whd-video__span{font-size: 34px;transform: translate(-50%, -50%);margin-top: 0px;}
.el-upload:hover .del_btn .whd-video__span{opacity: 1;}
</style>